/***************************************************************************
 * ========================================================================
 * Copyright 2024 VMware, Inc. All rights reserved. VMware Confidential
 * ========================================================================
 */

/**
 * Module containing components that are not intended for library user's usage,
 * but used for library's internal usage. This is to be deleted eventually as decoupling
 * of such components is not possible at the time of migration.
 * @preferred
 * @module AviInternalModule
 */

import { NgModule } from '@angular/core';
import { AviLabelWithTooltipComponent } from './components';

@NgModule({
  declarations: [
    AviLabelWithTooltipComponent,
  ],
  exports: [
    AviLabelWithTooltipComponent,
  ],
})
export class AviInternalModule {}
